export function truncateDesc(value, maxLength = 25) {
  if (!value) return '-';
  return value.length > maxLength ? value.slice(0, maxLength) + '...' : value;
}